import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import SimpleDataTables from '../Common/SimpleDataTables';
import CommonTableModal from './helpers/CommonTableModal';
import { getSupplierAndProductsAction, clearStateAction } from '../../redux/actions/admin/AdminAction';
import { getSuppliers } from '../../redux/actions/Supplier/SupplierAction';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SupplierAndProducts = ({ 
    getSupplierAndProductsAction, supplierAndProducts
}) => {
    const [rows, setRows] = useState([]);
    const [show, setShow] = useState(false);
    const [currentProducts, setCurrentProducts] = useState({});
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        // clearStateAction();
        setShow(false);
    };
    const handleShow = () => setShow(true);
    
    const handleGetProducts = (e, supplierId) => {
        setLoading(true);
        console.log('supplierId', supplierId);
        setCurrentProducts(() => supplierAndProducts.find(supplier => supplier.supplierId === supplierId));
        getSupplierAndProductsAction()
            .then(() => setLoading(false))
            .catch((error) => console.log('error', error));
        handleShow();
    };

    useEffect(() => {
        if (supplierAndProducts && supplierAndProducts.length === 0) {
            getSupplierAndProductsAction().catch((error) => console.log(error));
        }
        else {
            console.log('supplierAndProducts', supplierAndProducts);
            setRows(() => {
                return supplierAndProducts.map(supplier => {
                    return {
                        supplierId:supplier.supplierId, 
                        supplierName: supplier.supplierName, 
                        supplierPhoneNumber: supplier.supplierPhoneNumber
                    };
                });
            });
        }
    }, [supplierAndProducts]);

    const columns = [
        {
            label: 'Supplier Id',
            field: 'supplierId',
        },
        {
            label: 'Supplier Name',
            field: 'supplierName',
        },
        {
            label: 'Contact No',
            field: 'supplierPhoneNumber',
        }
    ];
    
    return (
        <div className='container'>
            <div className='row my-2 mb-4'>
                <div className='col-md-10 display-4'>Products By Supplier</div>
                <div className='col-md-2 mb-4 mt-3'>
                    <Link to='/admin' className='btn btn-sm btn-secondary'><FontAwesomeIcon className='FntIcon' key={1} icon={faArrowLeft} />&nbsp; &nbsp; Go Back</Link>
                </div>
            </div>
            {supplierAndProducts && supplierAndProducts.length === 0 ?
                (
                    <>
                        <div className="d-flex justify-content-center">
                            <div className="spinner-grow text-primary" role="status">
                            </div>
                        </div>
                        <p className='text-center'>Loading...</p>
                    </>
                ) :
                <SimpleDataTables button buttonText="View Products" funcParam="supplierId" buttonOnClick={handleGetProducts} columns={columns} rows={rows} />}
            <CommonTableModal loading={loading} show={show} handleClose={handleClose} data={currentProducts.products} />
        </div>
    );
};

SupplierAndProducts.defaultProps = {
    supplierAndProducts: []
};

const mapStateToProps = (state) => {
    console.log('supplierAndProducts state', state);
    return {
        // suppliers: state.suppliers,
        supplierAndProducts: state.admins  
    };
};

const mapDispatchToProps = {
    getSupplierAndProductsAction,
    clearStateAction,
    getSuppliers
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierAndProducts);